var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconAwesomeChartLine = function SvgIconAwesomeChartLine(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.333,
    height: 20.5,
    viewBox: "0 0 27.333 20.5",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-chart-line",
    "data-name": "Icon awesome-chart-line",
    d: "M26.479,21.583H3.417V5.354A.854.854,0,0,0,2.562,4.5H.854A.854.854,0,0,0,0,5.354V23.292A1.709,1.709,0,0,0,1.708,25H26.479a.854.854,0,0,0,.854-.854V22.437A.854.854,0,0,0,26.479,21.583ZM24.771,6.208h-6.3A1.281,1.281,0,0,0,17.562,8.4l1.73,1.73-3.917,3.917-3.917-3.917a1.708,1.708,0,0,0-2.416,0L5.375,13.793a.854.854,0,0,0,0,1.208l1.208,1.208a.854.854,0,0,0,1.208,0l2.459-2.459,3.917,3.917a1.708,1.708,0,0,0,2.416,0l5.125-5.125,1.73,1.73a1.281,1.281,0,0,0,2.187-.906v-6.3A.853.853,0,0,0,24.771,6.208Z",
    transform: "translate(0 -4.5)",
    fill: "#bcbcbc"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconAwesomeChartLine);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icon awesome-chart-line.0d2db33a1f3f1ea8ede95cf464057469.svg";